<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Customer Details</h1>

<div>
  <!-- Loading -->
  <mat-progress-spinner mode="indeterminate" *ngIf="isLoading"></mat-progress-spinner>

  <!-- Customer -->
  <div *ngIf="customer">
    <pre>{{customer | json}}</pre>
  </div>
</div>